import { isEmpty } from 'lodash';

const getDayConflicts = (day, conflicts) => {
  if (!day || !conflicts) {
    return [];
  }
  // day argument looks like 'schedules.current.workdays[5]'
  // so we just take the last index.
  const dayIndex = +day.substring(
    day.indexOf('[') + 1,
    day.lastIndexOf(']')
  ) + 1;

  return conflicts.find(conflict => conflict.weekDay === dayIndex && !isEmpty(conflict.conflicts));
};

export default getDayConflicts;
